module.exports = __webpack_public_path__ + "static/WSC_Group_2015_Self-Managed_Superfund_Checklist-aedfd7772d3b981ad0f6db30f73a82be.pdf";